// extracted by mini-css-extract-plugin
export default {"title":"SecondScreen_title__C0ZWr","description":"SecondScreen_description__l55Y8","row":"SecondScreen_row__zD1Q8","painSection":"SecondScreen_painSection__uKYah"};